module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/quickstart-rooms/select-params/select-params.component.html
// module id = 1589
// module chunks = 2